import { render, staticRenderFns } from "./DelCompaignTip.vue?vue&type=template&id=7f058f54&scoped=true"
import script from "./DelCompaignTip.vue?vue&type=script&lang=js"
export * from "./DelCompaignTip.vue?vue&type=script&lang=js"
import style0 from "./DelCompaignTip.vue?vue&type=style&index=0&id=7f058f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f058f54",
  null
  
)

export default component.exports